<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center" v-if="checkPermission('CreateRecensement')">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/fiche-recensement">
          Nouveau Recensement
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <Field name="total" v-model="leTotal" aria-disabled="true" type="text" disabled
          class="form-control text-center text-black shadow-none fs-md-15 text-black" />
      </div>
      <div class="d-flex align-items-center">
        <button type="button" @click="showExportModal()" v-if="valideEtape3"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
          <i class="fas fa-file-excel position-relative ms-5 fs-12"></i>
          Exporter Excel
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
          Génération...
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
        <!-- Section des filtres -->
        <div class="filter-section">
          <h6 class="mb-3 text-primary">
            <i class="fas fa-filter me-2"></i>Filtres de recherche
          </h6>
          <div class="row">
          <div class="col-md-3 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot clé
              </label>
              <Field v-model="motCle" name="mot" type="text" aria-disabled="true"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Nom, prénom, NPI..." />
              <ErrorMessage name="mot" class="text-danger" />
            </div>
          </div>
          <div class="col-md-3 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Agent
              </label>
              <Field name="agent" v-slot="{ field }" v-model="agent"
                class="form-control shadow-none fs-md-15 text-black">
                <Multiselect v-model="field.value" v-bind="field" :options="agentOptions" :searchable="true"
                  noResultText="Aucun enregistrement trouvé" placeholder="Sélectionner un agent" />
              </Field>
              <ErrorMessage name="agent" class="text-danger" />
            </div>
          </div>

          <div class="col-md-3 col-sm-6 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                État Usager
              </label>
              <Field name="etatUsager" v-slot="{ field }" v-model="etatUsager"
                class="form-control shadow-none fs-md-15 text-black">
                <Multiselect v-model="field.value" v-bind="field" :options="etatUsagerOptions" :searchable="true"
                  noResultText="Aucun état trouvé" placeholder="Sélectionner un état" />
              </Field>
              <ErrorMessage name="etatUsager" class="text-danger" />
            </div>
          </div>

          <div class="col-md-3 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Secteur d'activité
              </label>
              <Field v-model="secteurActivite" name="secteurActivite" type="text"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Secteur d'activité" />
              <ErrorMessage name="secteurActivite" class="text-danger" />
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="col-md-3 col-sm-6 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date début
              </label>
              <Field name="dateDebut" type="date" v-model="dateDebut"
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="dateDebut" class="text-danger" />
            </div>
          </div>

          <div class="col-md-3 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date fin
              </label>
              <Field name="dateFin" v-model="dateFin" type="date"
                class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="dateFin" class="text-danger" />
            </div>
          </div>

          <div class="col-md-3 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type Marchand
              </label>
              <Field name="typeMarchand" v-slot="{ field }" v-model="typeMarchand"
                class="form-control shadow-none fs-md-15 text-black">
                <Multiselect v-model="field.value" v-bind="field" :options="typeMarchandOptions" :searchable="true"
                  noResultText="Aucun type trouvé" placeholder="Sélectionner un type" />
              </Field>
              <ErrorMessage name="typeMarchand" class="text-danger" />
            </div>
          </div>

          <div class="col-md-3 col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Actions
              </label>
              <div class="d-flex gap-2">
                <button type="button" @click="resetFilters" class="btn btn-outline-secondary btn-sm btn-filter">
                  <i class="fas fa-undo me-1"></i>
                  Réinitialiser
                </button>
                <button type="button" @click="searchWithFilters" class="btn btn-primary btn-sm btn-filter">
                  <i class="fas fa-search me-1"></i>
                  Rechercher
                </button>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                #
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Nom
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Prénom
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                NPI
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                État
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Emplacement
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Agent
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(recensement, index) in recensements" :key="index">
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ recensement.id }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ recensement.nom }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-primary">
                {{ recensement.prenom }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ recensement.npiUsager || 'N/A' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span class="badge" :class="getEtatBadgeClass(recensement.etatUsager)">
                  {{ recensement.etatUsager }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ recensement.codeemp || 'N/A' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ recensement.nomPrenomAgent || 'N/A' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date(recensement.createdAt, 'DD/MM/YYYY') }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <span class="badge text-white bg-secondary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a @click="openNewWindow(recensement)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                        Aperçu de la fiche
                      </a>
                    </li>
                    <li>
                      <a @click="viewRecensement(recensement)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                        Voir détails
                      </a>
                    </li>
                    <li v-if="checkPermission('DeleteRecensement')">
                      <a href="javascript:void(0);" data-bs-target="#delete-modal" data-bs-toggle="modal"
                        @click="openDeleteModal(recensement.id)" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-trash lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <!-- Modal de suppression -->
      <div class="modal fade" id="delete-modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Voulez-vous supprimer ce recensement ?</h6>
              <button type="button" id="close-delete-modal" class="btn-close" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div class="modal-body px-4">
              <p>Cette action est irréversible.</p>
            </div>
            <div class="modal-footer">
              <button type="button" @click="deleteRecensement" class="btn btn-danger">Supprimer</button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal d'export -->
      <div class="modal fade" id="export-modal" tabindex="-1" aria-hidden="true" @click.self="closeExportModal">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <i class="fas fa-file-excel me-2 text-success"></i>
                Options d'export Excel
              </h5>
              <button type="button" class="btn-close" @click="closeExportModal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12 mb-3">
                  <h6 class="text-primary mb-3">
                    <i class="fas fa-columns me-2"></i>Colonnes à inclure
                  </h6>
                  <div class="row">
                    <div class="col-md-6" v-for="(column, key) in exportColumns" :key="key">
                      <div class="form-check mb-2">
                        <input class="form-check-input" type="checkbox" :id="'col-' + key" 
                               v-model="exportColumns[key].selected">
                        <label class="form-check-label" :for="'col-' + key">
                          {{ column.label }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="d-flex gap-2 mb-2">
                    <button type="button" @click="selectAllColumns" class="btn btn-outline-primary btn-sm">
                      <i class="fas fa-check-square me-1"></i>
                      Tout sélectionner
                    </button>
                    <button type="button" @click="deselectAllColumns" class="btn btn-outline-secondary btn-sm">
                      <i class="fas fa-square me-1"></i>
                      Tout désélectionner
                    </button>
                  </div>
                  <small class="text-muted">
                    <i class="fas fa-info-circle me-1"></i>
                    {{ selectedColumnsCount }} colonne(s) sélectionnée(s)
                  </small>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeExportModal">
                <i class="fas fa-times me-1"></i>
                Annuler
              </button>
              <button type="button" @click="performExport" class="btn btn-success" :disabled="selectedColumnsCount === 0">
                <i class="fas fa-download me-1"></i>
                Exporter ({{ selectedColumnsCount }} colonnes)
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, onMounted, watch, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import {
  showModal,
  suppression,
  separateur,
  format_Date,
  format_date,
  supprimerElement,
  error,
  dateActuelle,
  success,
  checkPermission,
  getUrlApiForFiles,
} from "@/utils/utils";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import Multiselect from "@vueform/multiselect";
import axios from "axios";
import Swal from "sweetalert2";
import * as Yup from 'yup';

export default defineComponent({
  name: "ListeRecensement",
  components: {
    PaginationComponent,
    Field,
    ErrorMessage,
    Multiselect,
  },
  setup: () => {
    // BEGIN PAGINATE
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const motCle = ref("");
    const dateFin = ref(dateActuelle());
    const dateDebut = ref(dateActuelle());
    const leTotal = ref("0");
    const donn = ref();
    const recensementId = ref<number | null>(null);

    // END PAGINATE
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche(page_, limit_);
      } catch (error) {
        //
      }
    };

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
     function openNewWindow(data: any, dossier = "FicheDeRecensement") {
      openAndPrint(getUrlApiForFiles(dossier, data.nomDocument+".pdf"));
    }

    const getUser = async () => {
      try {
        const response = await axios.get("/tout/users",);
        const donnee = response.data.data;
        agentOptions.value = donnee.map((agent) => ({
          value: agent.id,
          label: agent.nomComplet,
        }));
      } catch (error) {
        //
      }
    };

    function triggerButtonClick(buttonId: string) {
      const button = document.getElementById(buttonId) as HTMLButtonElement;
      if (button) {
        button.click();
      } else {
        console.error(`Button with ID "${buttonId}" not found.`);
      }
    }

    const valideEtape3 = ref(true);
    const recharger = () => {
      actionRecherche(page.value, limit.value);
    };
    const agent = ref();
    const agentOptions = ref();
    const etatUsager = ref();
    const etatUsagerOptions = ref([
      { value: 'Existant', label: 'Existant' },
      { value: 'Non Existant', label: 'Non Existant' }
    ]);
    const secteurActivite = ref('');
    const typeMarchand = ref();
    const typeMarchandOptions = ref([
      { value: 'boutique', label: 'Boutique' },
      { value: 'stand', label: 'Stand' },
      { value: 'marchand ambulant', label: 'Marchand Ambulant' },
      { value: 'autre', label: 'Autre' }
    ]);
    const recensements: any = ref<Array<any>>([]);

    // Variables pour l'export avec options
    const exportColumns = ref({
      id: { label: 'ID', selected: true, key: 'id' },
      nom: { label: 'Nom', selected: true, key: 'nom' },
      prenom: { label: 'Prénom', selected: true, key: 'prenom' },
      npiUsager: { label: 'NPI', selected: true, key: 'npiUsager' },
      matricule: { label: 'Matricule', selected: true, key: 'matricule' },
      etatUsager: { label: 'État Usager', selected: true, key: 'etatUsager' },
      telephone: { label: 'Téléphone', selected: false, key: 'telephone' },
      email: { label: 'Email', selected: false, key: 'email' },
      secteurActivite: { label: 'Secteur d\'activité', selected: true, key: 'secteurActivite' },
      typeMarchand: { label: 'Type Marchand', selected: true, key: 'typeMarchand' },
      codeemp: { label: 'Emplacement', selected: true, key: 'codeemp' },
      anciennete: { label: 'Ancienneté', selected: false, key: 'anciennete' },
      nombrePersonnes: { label: 'Nombre de personnes', selected: false, key: 'nombrePersonnes' },
      nomPrenomAgent: { label: 'Agent recenseur', selected: true, key: 'nomPrenomAgent' },
      telephoneAgent: { label: 'Téléphone agent', selected: false, key: 'telephoneAgent' },
      emailAgent: { label: 'Email agent', selected: false, key: 'emailAgent' },
      observations: { label: 'Observations', selected: false, key: 'observations' },
      dateRecensement: { label: 'Date recensement', selected: true, key: 'dateRecensement' },
      createdAt: { label: 'Date création', selected: true, key: 'createdAt' }
    });

    const openDeleteModal = (id: number) => {
      recensementId.value = id;
    };

    const deleteRecensement = async () => {
      if (!recensementId.value) return;
      
      try {
        const response = await ApiService.delete(`/recensement-usager/${recensementId.value}`);
        if (response.data.success) {
          success("Recensement supprimé avec succès");
          await actionRecherche(1, 10);
          triggerButtonClick("close-delete-modal");
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const viewRecensement = (recensement: any) => {
      Swal.fire({
        title: 'Détails du recensement',
        html: `
          <div class="text-left">
            <p><strong>ID:</strong> ${recensement.id}</p>
            <p><strong>Nom:</strong> ${recensement.nom}</p>
            <p><strong>Prénom:</strong> ${recensement.prenom}</p>
            <p><strong>NPI:</strong> ${recensement.npiUsager || 'N/A'}</p>
            <p><strong>État:</strong> ${recensement.etatUsager}</p>
            <p><strong>Emplacement:</strong> ${recensement.emplacement?.codeemp || 'N/A'}</p>
            <p><strong>Agent:</strong> ${recensement.userCreation?.nom || 'N/A'}</p>
            <p><strong>Date:</strong> ${format_date(recensement.createdAt, 'DD/MM/YYYY')}</p>
          </div>
        `,
        confirmButtonText: 'Fermer'
      });
    };

    const editRecensement = (recensement: any) => {
      // Navigation vers le formulaire d'édition
      window.location.href = `/recensement-form?id=${recensement.id}`;
    };

    const actionRecherche = async (page = 1, limi = 10, searchTerm = "") => {
      const element = {
        dateDebut: (dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
        dateFin: (dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
        motCle: motCle.value,
        recherche: motCle.value,
        agent: agent.value,
        etatUsager: etatUsager.value,
        secteurActivite: secteurActivite.value,
        typeMarchand: typeMarchand.value,
        page: page,
        totalPages: totalPages.value,
        limit: limi,
        totalElements: totalElements.value,
        mot: searchTerm,
      };
      donn.value = element;
      try {
        const response = await axios.post("recensement-usager/liste", element);
        recensements.value = response.data.data.data;
        totalPages.value = response.data.data.totalPages;
        limit.value = response.data.data.limit;
        totalElements.value = response.data.data.totalElements;
        leTotal.value = separateur(response.data.data.total) + " (Recensements)";
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const searchWithFilters = async () => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      await actionRecherche(page.value, limit.value);
    };

    const resetFilters = () => {
      motCle.value = '';
      agent.value = null;
      etatUsager.value = null;
      secteurActivite.value = '';
      typeMarchand.value = null;
      dateDebut.value = dateActuelle();
      dateFin.value = dateActuelle();
      searchWithFilters();
    };

    // Fonctions pour l'export avec options
    const selectedColumnsCount = computed(() => {
      return Object.values(exportColumns.value).filter(col => col.selected).length;
    });

    const showExportModal = () => {
      const modalElement = document.getElementById('export-modal');
      if (modalElement) {
        if (typeof window !== 'undefined' && (window as any).bootstrap) {
          const modal = new (window as any).bootstrap.Modal(modalElement);
          modal.show();
        } else {
          // Fallback si Bootstrap n'est pas disponible
          modalElement.style.display = 'block';
          modalElement.classList.add('show');
          modalElement.setAttribute('aria-modal', 'true');
          modalElement.setAttribute('role', 'dialog');
          
          // Ajouter la classe backdrop
          const backdrop = document.createElement('div');
          backdrop.className = 'modal-backdrop fade show';
          backdrop.id = 'export-modal-backdrop';
          document.body.appendChild(backdrop);
          
          // Empêcher le scroll du body
          document.body.classList.add('modal-open');
        }
      }
    };

    const selectAllColumns = () => {
      Object.keys(exportColumns.value).forEach(key => {
        exportColumns.value[key].selected = true;
      });
    };

    const deselectAllColumns = () => {
      Object.keys(exportColumns.value).forEach(key => {
        exportColumns.value[key].selected = false;
      });
    };

    const closeExportModal = () => {
      const modalElement = document.getElementById('export-modal');
      if (modalElement) {
        if (typeof window !== 'undefined' && (window as any).bootstrap) {
          const modal = (window as any).bootstrap.Modal.getInstance(modalElement);
          if (modal) {
            modal.hide();
          }
        } else {
          // Fallback si Bootstrap n'est pas disponible
          modalElement.style.display = 'none';
          modalElement.classList.remove('show');
          modalElement.removeAttribute('aria-modal');
          modalElement.removeAttribute('role');
          
          // Supprimer le backdrop
          const backdrop = document.getElementById('export-modal-backdrop');
          if (backdrop) {
            backdrop.remove();
          }
          
          // Restaurer le scroll du body
          document.body.classList.remove('modal-open');
        }
      }
    };

    const performExport = async () => {
      try {
        // Fermer le modal
        closeExportModal();

        valideEtape3.value = false;
        
        

        // Fonction pour formater la date correctement
        const formatDate = (dateString: string) => {
          const date = new Date(dateString);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        const exportData = {
          dateDebut: formatDate(dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
          dateFin: formatDate(dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
          motCle: motCle.value,
          recherche: motCle.value,
          agent: agent.value,
          etatUsager: etatUsager.value,
          secteurActivite: secteurActivite.value,
          typeMarchand: typeMarchand.value,
          selectedColumns: Object.keys(exportColumns.value).filter(key => exportColumns.value[key].selected)
        };
        
        const response = await ApiService.post("/recensement-usager/export/excel", exportData);

        // Afficher un message de progression
        const progressToast = Swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            Swal.showLoading();
          }
        });
        
        await progressToast.fire({
          icon: 'info',
          title: 'Génération du fichier Excel en cours...'
        });

        if(response.status == 200){
          success("Export réussi!");
          openAndPrint(getUrlApiForFiles("Excel", response.data.data.nomFichier));
          }else{
            error(response.data.message);
          }        
        
        valideEtape3.value = true;
      } catch (err) {
        console.error('Erreur lors de l\'export:', err);
        console.error('Type d\'erreur:', typeof err);
        console.error('Erreur complète:', JSON.stringify(err, null, 2));
        
        let errorMessage = 'Erreur lors de l\'export du fichier Excel';
        let errorDetails = '';
        
        if (axios.isAxiosError(err)) {
          console.error('Erreur Axios détectée');
          console.error('Status:', err.response?.status);
          console.error('Status Text:', err.response?.statusText);
          console.error('Headers:', err.response?.headers);
          console.error('Data:', err.response?.data);
          
          if (err.code === 'ECONNABORTED') {
            errorMessage = 'Timeout: L\'export prend trop de temps. Veuillez réduire la période ou les filtres.';
          } else if (err.response) {
            errorMessage = err.response.data?.message || err.message || 'Erreur serveur';
            errorDetails = `Status: ${err.response.status} - ${err.response.statusText}`;
          } else if (err.request) {
            errorMessage = 'Erreur de connexion au serveur';
            errorDetails = 'Vérifiez que le serveur backend est démarré';
          } else {
            errorMessage = err.message || 'Erreur inconnue';
          }
        } else {
          errorMessage = err instanceof Error ? err.message : 'Erreur inconnue';
        }
        
        Swal.fire({
          icon: 'error',
          title: 'Erreur d\'export',
          html: `<strong>${errorMessage}</strong>${errorDetails ? `<br><small>${errorDetails}</small>` : ''}`,
          confirmButtonText: 'OK'
        });
        
        valideEtape3.value = true;
      }
    };


    const getEtatBadgeClass = (etat: string) => {
      switch (etat) {
        case 'Existant':
          return 'badge-success';
        case 'Non Existant':
          return 'badge-warning';
        default:
          return 'badge-secondary';
      }
    };

    // Variables pour le debounce
    let searchTimeout: any = null;
    const searchDelay = 500; // 500ms de délai

    // Fonction de recherche avec debounce
    const debouncedSearch = (callback: () => void) => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
      searchTimeout = setTimeout(callback, searchDelay);
    };

    // Watchers avec debounce
    watch(motCle, async (newValue, oldValue) => {
      debouncedSearch(async () => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        await actionRecherche(page.value, limit.value);
      });
    });

    watch(dateFin, (newValue, oldValue) => {
      debouncedSearch(() => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        actionRecherche(page.value, limit.value);
      });
    });

    watch(agent, (newValue, oldValue) => {
      debouncedSearch(() => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        actionRecherche(page.value, limit.value);
      });
    });

    watch(dateDebut, (newValue, oldValue) => {
      debouncedSearch(() => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        actionRecherche(page.value, limit.value);
      });
    });

    // Nouveaux watchers pour les nouveaux filtres
    watch(etatUsager, (newValue, oldValue) => {
      debouncedSearch(() => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        actionRecherche(page.value, limit.value);
      });
    });

    watch(secteurActivite, (newValue, oldValue) => {
      debouncedSearch(() => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        actionRecherche(page.value, limit.value);
      });
    });

    watch(typeMarchand, (newValue, oldValue) => {
      debouncedSearch(() => {
        page.value = 1;
        limit.value = 10;
        totalPages.value = 0;
        totalElements.value = 0;
        actionRecherche(page.value, limit.value);
      });
    });

    onMounted(async () => {
      await actionRecherche(1, 10);
      await getUser();
      
      // Ajouter un gestionnaire pour la touche Échap
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const exportModal = document.getElementById('export-modal');
          if (exportModal && exportModal.style.display === 'block') {
            closeExportModal();
          }
        }
      });
    });

    return {
      dateDebut,
      dateFin,
      suppression,
      recharger,
      page,
      agentOptions,
      agent,
      etatUsager,
      etatUsagerOptions,
      secteurActivite,
      typeMarchand,
      typeMarchandOptions,
      viewRecensement,
      editRecensement,
      recensements,
      totalPages,
      limit,
      format_date,
      format_Date,
      separateur,
      totalElements,
      handlePaginate,
      searchTerm,
      motCle,
      error,
      leTotal,
      checkPermission,
      valideEtape3,
      dateActuelle,
      openDeleteModal,
      deleteRecensement,
      getEtatBadgeClass,
      openNewWindow,
      openAndPrint,
      searchWithFilters,
      resetFilters,
      exportColumns,
      selectedColumnsCount,
      showExportModal,
      closeExportModal,
      selectAllColumns,
      deselectAllColumns,
      performExport,
    };
  },
});
</script>

<style scoped>
/* Styles pour les filtres */
.filter-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
}

.filter-row {
  margin-bottom: 15px;
}

.filter-row:last-child {
  margin-bottom: 0;
}

.form-group label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 8px;
}

.form-control, .multiselect {
  border: 2px solid #e3e6f0;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.form-control:focus, .multiselect:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-filter {
  border-radius: 6px;
  font-weight: 500;
  padding: 8px 16px;
  transition: all 0.3s ease;
}

.btn-filter:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Styles pour les badges d'état */
.badge-success {
  background-color: #28a745 !important;
  color: white !important;
}

.badge-warning {
  background-color: #ffc107 !important;
  color: #212529 !important;
}

.badge-secondary {
  background-color: #6c757d !important;
  color: white !important;
}

/* Styles pour le tableau */
.table th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
}

.table td {
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
}

/* Animation pour le loading */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

.loading-pulse {
  animation: pulse 1.5s infinite;
}

/* Styles pour les boutons d'action */
.dropdown-toggle {
  background: linear-gradient(45deg, #007bff, #0056b3);
  border: none;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.dropdown-toggle:hover {
  background: linear-gradient(45deg, #0056b3, #004085);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,123,255,0.3);
}

.dropdown-item {
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
  color: #007bff;
}

/* Responsive */
@media (max-width: 768px) {
  .filter-section {
    padding: 15px;
  }
  
  .btn-filter {
    width: 100%;
    margin-bottom: 10px;
  }
  
  .table-responsive {
    font-size: 0.875rem;
  }
}

/* Styles pour les icônes Font Awesome */
.fas {
  font-weight: 900;
}

/* Amélioration du bouton d'export */
.btn-export {
  background: linear-gradient(45deg, #28a745, #20c997);
  border: none;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.btn-export:hover {
  background: linear-gradient(45deg, #20c997, #17a2b8);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

.btn-export:disabled {
  background: #6c757d;
  transform: none;
  box-shadow: none;
}
</style>
